import { type } from '@/utils/type'


export const ADMINMISSION_REQUEST = type('ADMINMISSION_REQUEST')
export const ADMINMISSION_SUCCESS = type('ADMINMISSION_SUCCESS')
export const ADMINMISSION_ERROR = type('ADMINMISSION_ERROR')

export const ADMINMISSION_ENSURE_LIST = type('ADMINMISSION_ENSURE_LIST')

export const ADMINMISSION_SELECT_DETAIL_REQUEST = type('ADMINMISSION_SELECT_DETAIL_REQUEST')
export const ADMINMISSION_SELECT_DETAIL_SUCCESS = type('ADMINMISSION_SELECT_DETAIL_SUCCESS')
export const ADMINMISSION_SELECT_DETAIL_ERROR = type('ADMINMISSION_SELECT_DETAIL_ERROR')
export const ADMINMISSION_SELECT_DETAIL = type('ADMINMISSION_SELECT_DETAIL')

export const ADMINMISSION_SAVE_REQUEST = type('ADMINMISSION_SAVE_REQUEST')
export const ADMINMISSION_SAVE_SUCCESS = type('ADMINMISSION_SAVE_SUCCESS')
export const ADMINMISSION_SAVE_ERROR = type('ADMINMISSION_SAVE_ERROR')

export const ADMINMISSION_DELETE_REQUEST = type('ADMINMISSION_DELETE_REQUEST')
export const ADMINMISSION_DELETE_SUCCESS = type('ADMINMISSION_DELETE_SUCCESS')
export const ADMINMISSION_DELETE_ERROR = type('ADMINMISSION_DELETE_ERROR')

export const ADMINMISSION_UPDATE_MODIFIED_ADM = type('ADMINMISSION_UPDATE_MODIFIED_ADM')
export const ADMINMISSION_CANCEL_MODIFIED_ADM = type('ADMINMISSION_CANCEL_MODIFIED_ADM')

export const ADMINMISSION_UPDATE_FILTER_ADM = type('ADMINMISSION_UPDATE_FILTER_ADM')

export const ADMINMISSION_EXTERNAL_UPDATE = type('ADMINMISSION_EXTERNAL_UPDATE')
export const ADMINMISSION_ROLEMAPPING_EXTERNAL_UPDATE = type('ADMINMISSION_ROLEMAPPING_EXTERNAL_UPDATE')

export const ADMINMISSION_ENSURE_ROLEMAPPING = type('ADMINMISSION_ENSURE_ROLEMAPPING')
export const ADMINMISSION_ROLEMAPPING_REQUEST = type('ADMINMISSION_ROLEMAPPING_REQUEST')
export const ADMINMISSION_ROLEMAPPING_SUCCESS = type('ADMINMISSION_ROLEMAPPING_SUCCESS')
export const ADMINMISSION_ROLEMAPPING_ERROR = type('ADMINMISSION_ROLEMAPPING_ERROR')

export const ADMINMISSION_ADD_ROLEMAPPING_SUCCESS = type('ADMINMISSION_ADD_ROLEMAPPING_SUCCESS')
export const ADMINMISSION_REMOVE_ROLEMAPPING_SUCCESS = type('ADMINMISSION_REMOVE_ROLEMAPPING_SUCCESS')
